<template>

<div class="dropdown" style="float:right;padding-bottom:10px;">
<a class="navigation-link item pr-0 pl-4" style="text-decoration:none;" href="/cart">
<div class="cart-icon">
<i class="fas fa-shopping-basket" style="font-size:12px;margin-right:7px;"></i>{{itemCount}}
</div></a>
  <div class="dropdown-content shadow hide-mobile">
      <a href="/cart">View cart</a>
      <a href="/checkout">Checkout</a>
  </div>
</div>
</template>

<script>
import { EventBus } from '../bus';

export default {

  data() {
    return {
      itemCount: 0,
      loading: false,
    };
  },

  created() {
    this.getItems();

    EventBus.$on('update-cart', (product) => {
      this.getItems();
    });

  },

  methods: {

    getItems() {
      axios.get('/cart/item-count')
        .then((response) => {
          this.itemCount = response.data;
        });
    },

  },
};
</script> 

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content { 
  position: absolute;
  top: 38px;
  left: -65px;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  margin-top: 0.125rem;
  font-size: 0.9rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-content a {
  padding: 0.25rem 1.5rem;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {background-color: #e9ecef;}
.dropdown:hover .dropdown-content {display: block;}
</style>
